import api from '@/api';
import utilities from '@/helpers/utilities';
import i18n from '@/i18n';

const state = {
    evaluation: {},
};

const mutations = {
    setEvaluation(state, evaluation) {
        state.evaluation = evaluation;
    },
};

const actions = {
    async getEvaluation({ commit }, data) {
        const response = await api.evaluations.get(data.demandId, data.personId);
        commit('setEvaluation', response.data);
    },
    async saveOrUpdateEvaluation({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveEvaluation', form);
        } else {
            await dispatch('updateEvaluation', form);
        }

        dispatch('showSuccess', i18n.t('message.success.evaluationSaved'));
    },
    async saveEvaluation({ commit }, form) {
        await api.evaluations.save(form);
        commit('setEvaluation', form);
    },

    async updateEvaluation({ commit }, form) {
        await api.evaluations.update(form.id, form);
        commit('setEvaluation', form);
    },

    async removeEvaluation({ dispatch }, form) {
        await api.evaluations.remove(form.id);

        dispatch('showSuccess', i18n.t('message.success.evaluationRemoved'));
    },
};

const getters = {
    evaluation() {
        return state.evaluation || {};
    }
};

export default {
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/modules/evaluations.js